/** Motivos de recusa do login único (ADR 0007). A API redireciona com o código; a web mostra a mensagem. */

export type CodigoErroSso =
  | 'desligado'
  | 'token_invalido'
  | 'token_reutilizado'
  | 'sem_permissao'
  | 'sem_email'
  | 'conflito_tipo'
  | 'sem_empresa'
  | 'usuario_inativo'
  | 'origem_indisponivel'

export const MENSAGENS_SSO: Record<CodigoErroSso, string> = {
  desligado: 'O login único ainda não está configurado neste servidor. Fale com o administrador.',
  token_invalido: 'O link de acesso é inválido ou expirou. Abra o Via Tax de novo pelo menu do sistema de origem.',
  token_reutilizado: 'Este link de acesso já foi usado. Abra o Via Tax de novo pelo menu do sistema de origem.',
  sem_permissao: 'Seu usuário não está liberado para o Via Tax. Peça a liberação ao administrador.',
  sem_email: 'Seu usuário não tem e-mail cadastrado na origem, e o e-mail é obrigatório para o acesso.',
  conflito_tipo: 'Este e-mail já é usado por outro tipo de acesso no Via Tax (escritório × cliente). Fale com o escritório.',
  sem_empresa: 'Nenhuma das suas empresas está habilitada no Via Tax ainda. Fale com o escritório.',
  usuario_inativo: 'Seu usuário está desativado no Via Tax. Fale com o escritório.',
  origem_indisponivel: 'Não foi possível confirmar seu acesso agora (sistema de origem fora do ar). Tente de novo em instantes.',
}

export function mensagemSso(codigo: string | null | undefined): string | null {
  if (!codigo) return null
  return (MENSAGENS_SSO as Record<string, string>)[codigo] ?? MENSAGENS_SSO.token_invalido
}
